import { render, staticRenderFns } from "./MonthsEstablishmentSettingDelete.vue?vue&type=template&id=b0b98112&scoped=true&"
import script from "./MonthsEstablishmentSettingDelete.vue?vue&type=script&lang=js&"
export * from "./MonthsEstablishmentSettingDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b98112",
  null
  
)

export default component.exports